<template>
  <section class="pbr-topic-container">
    <section class="pbr-topicb-top-img">
      <img
        alt="专题"
        :src="topic.picture ? topic.picture : 'static/images/pbr/topicb.png'"
      />
    </section>
    <div style="width: 100%;" class="pbr-topic-top">
      <div style="display: flex; font-weight: bold;margin-top: 15px;">
        <span
          style="font-size: 22px; font-weight: 600;margin-left: 25px;"
          :title="topic.title"
          >{{ topic.title }}</span
        >
      </div>

      <div
        style="font-weight: 400; line-height: 22px; font-size: 14px;overflow: hidden;margin-left: 25px;margin-top: 15px;text-indent: 28px;"
      >
        {{ topic.summary }}
      </div>
    </div>
    <section class="pbr-topic-content">
      <Row>
        <Col :xs="24" :sm="24" :lg="12">
          <section class="pbr-topic-project-publish">
            <div class="pbr-topicb-title-panel">
              <Icon
                class="pbr-topicb-title-panel-radio"
                type="md-radio-button-on"
              />
              <strong>{{
                $t("label.special.distributionOfRelatedProjects")
              }}</strong>
            </div>
            <div class="pbr-topic-content">
              <Tabs type="card">
                <TabPane :label="$t('tabs.special.regionalDistribution')">
                  <div class="pbr-topic-content-chart">
                    <div class="pbr-topic-content-desc ">
                      {{ topic.regionDescribe }}
                    </div>
                    <div style="flex: 1">
                      <region-dist-chart
                        :data="regionDistChartData"
                      ></region-dist-chart>
                    </div>
                  </div>
                </TabPane>
                <TabPane :label="$t('tabs.special.industryDistribution')">
                  <div class="pbr-topic-content-chart">
                    <div class="pbr-topic-content-desc ">
                      {{ topic.industryDescribe }}
                    </div>
                    <div style="flex: 1">
                      <industry-dist-chart
                        :data="industryDistChatData"
                      ></industry-dist-chart>
                    </div>
                  </div>
                </TabPane>
              </Tabs>
            </div>
          </section>
        </Col>
        <Col :xs="24" :sm="24" :lg="12">
          <section class="pbr-topic-project-info">
            <div class="pbr-topicb-title-panel">
              <Icon
                class="pbr-topicb-title-panel-radio"
                type="md-radio-button-on"
              />
              <strong>{{
                $t("label.special.projectRelatedInformation")
              }}</strong>
            </div>
            <div class="pbr-topic-content" style="">
              <Tabs type="card">
                <TabPane :label="$t('tabs.special.informationAtlas')">
                  <div class="pbr-topic-content-chart">
                    <div class="pbr-topic-content-desc ">
                      {{ topic.atlasDescribe }}
                    </div>
                    <div style="flex: 1;height: 180px;">
                      <div
                        class="content-graph pr-sm-0 pl-sm-0"
                        :class="[isFull ? 'fullscreen' : '']"
                      >
                        <div
                          class="graph-wrap"
                          id="graph-wrap"
                          style="height: 100%"
                        >
                          <!--                @fullGraph="fullGraph"-->
                          <copy-normal-graph
                            :value="graphValue"
                            id="pbrTopicInfo"
                            class="normal-graph"
                            ref="graph"
                            is-full="#graph-wrap"
                            :is-center="true"
                            :isRollZomm="true"
                            :is-roll-zomm-num="true"
                            :is-real-full="false"
                            :is-layout="false"
                            :has-legend="true"
                            @fullGraph="fullGraph"
                            @changeGraph="changeGraph"
                          ></copy-normal-graph>
                        </div>
                      </div>
                      <!--                    <infographic-chart></infographic-chart>-->
                      <!--                    <atlas-analysis></atlas-analysis>-->
                    </div>
                  </div>
                </TabPane>
                <TabPane :label="$t('tabs.special.hotWordAnalysis')">
                  <div class="pbr-topic-content-chart">
                    <div class="pbr-topic-content-desc ">
                      {{ topic.hotWordsDescribe }}
                    </div>
                    <div style="flex: 1;height: 180px;">
                      <hot-word-analysis
                        v-if="hotWordDistChartData.length"
                        :word-data="hotWordDistChartData"
                        :size-range="[8, 12]"
                      ></hot-word-analysis>
                    </div>
                  </div>
                </TabPane>
              </Tabs>
            </div>
          </section>
        </Col>
        <Col :xs="24" :sm="24" :lg="12">
          <section class="pbr-topic-project">
            <div class="pbr-topicb-title-panel pbr-topicb-title-flex">
              <div>
                <Icon
                  class="pbr-topicb-title-panel-radio"
                  type="md-radio-button-on"
                />
                <strong>{{
                  topic.projectColumnName
                    ? topic.projectColumnName
                    : $t("label.special.relatedItems")
                }}</strong>
              </div>
              <span @click="lookMore('1')">{{ $t("buttons.more") }}</span>
            </div>
            <div class="pbr-topic-content">
              <infinite-scroll-list
                v-if="topic.id"
                :key="infiniteKey"
                url="/front/special/querySpecialProject"
                :item-click="
                  (detail) => {
                    this.$router.push({
                      name: 'pbrProjectDetail',
                      query: { key: detail.pid },
                    });
                  }
                "
                list-key="records"
                :columns="['ptitle', 'pPublishDate']"
                :params="{
                  id: topic.id,
                  lang: locale,
                  pageSize: 10,
                  pageNo: 1,
                }"
                method="GET"
                :page-size="6"
              ></infinite-scroll-list>
            </div>
          </section>
        </Col>
        <Col :xs="24" :sm="24" :lg="12">
          <section class="pbr-topic-info">
            <div class="pbr-topicb-title-panel pbr-topicb-title-flex">
              <div>
                <Icon
                  class="pbr-topicb-title-panel-radio"
                  type="md-radio-button-on"
                />
                <strong>{{
                  topic.articleColumnName
                    ? topic.articleColumnName
                    : $t("label.special.relevantInformation")
                }}</strong>
              </div>
              <span @click="lookMore('2')">{{ $t("buttons.more") }}</span>
            </div>
            <div class="pbr-topic-content">
              <infinite-scroll-list
                v-if="topic.id"
                :key="infiniteKey1"
                url="/front/special/querySpecialNews"
                :item-click="
                  (detail) => {
                    this.$router.push({
                      name: 'pbrInfoDetail',
                      query: { key: detail.articleId },
                    });
                  }
                "
                list-key="records"
                :columns="['title', 'articleTime']"
                :params="{
                  id: topic.id,
                  lang: locale,
                  pageSize: 10,
                  pageNo: 1,
                }"
                method="GET"
                :page-size="6"
              ></infinite-scroll-list>
            </div>
          </section>
        </Col>
      </Row>
    </section>
    <div style="width:100%;padding-bottom: 20px;">
      <Table
        border
        :columns="columns"
        :data="tableData"
        :loading="tableLoading"
        style="margin-top: 10px;"
      >
        <template slot-scope="{ row }" slot="title">
          <div
            class="topic-table-title"
            style="cursor:pointer;overflow:hidden;text-overflow: ellipsis;"
            @click="refresh(row)"
            v-html="row.title"
          ></div>
        </template>
      </Table>
    </div>
    <MoreProject ref="moreRef"></MoreProject>
  </section>
</template>

<script>
import NormalList from "../index/NormalList";
import TestData from "./TestData.js";
import RegionDistChart from "./RegionDistChart";
import IndustryDistChart from "./IndustryDistChart";
import InfographicChart from "./InfographicChart";
// import HotWordAnalysis from './HotWordAnalysis'
import HotWordAnalysis from "../analysis/HotWordAnalysis";
import AtlasAnalysis from "../analysis/AtlasAnalysis";
import InfiniteScrollList from "./InfiniteScrollList";
import MoreProject from "./MoreProject.vue";
import CopyNormalGraph from "../analysis/CopyNormalGraph";

export default {
  name: "pbrTopicIndex",
  components: {
    CopyNormalGraph,
    InfiniteScrollList,
    AtlasAnalysis,
    NormalList,
    RegionDistChart,
    IndustryDistChart,
    InfographicChart,
    MoreProject,
    HotWordAnalysis,
  },
  data() {
    return {
      topic: {},
      infiniteKey: new Date().getTime(),
      infiniteKey1: new Date().getTime(),
      hotWordDistChartData: [],
      isFull: false,
      pbrTopicProject: [],
      pbrTopicInfo: [],
      regionDistChartData: [],
      industryDistChatData: [],
      specialList: [],
      graphValue: {
        graph: null,
        haveNoPage: true,
        // layout: 'force'
        layout: "static",
      },
      locale: localStorage.getItem("locale"),
      tableLoading: false,
      projectColums: [],
      columns: [
        {
          title: this.$t("table.topic.list.no"),
          type: "index",
          width: 60,
          align: "center",
          fixed: "left",
        },
        {
          title: this.$t("table.topic.list.title"),
          slot: "title",
          minWidth: 300,
          className: "table-head-style",
        },
        {
          title: this.$t("table.topic.list.summary"),
          key: "summary",
          minWidth: 200,
          className: "table-head-style",
        },
        {
          title: this.$t("table.topic.list.releaseTime"),
          key: "releaseTime",
          width: 200,
          align: "center",
          sortable: "custom",
        },
      ],
      tableData: [],
    };
  },
  created() {},
  mounted() {
    this.getTopic();
    this.getTopicList();
    this.$nextTick(() => {
      this.$refs.graph.loading = true;
    });
  },
  methods: {
    lookMore(val) {
      this.$refs.moreRef.open(val, this.topic.id, this.projectColums);
    },
    refresh(row) {
      this.topic = row;
      if (row.projectColumnConf) {
        this.projectColums = JSON.parse(row.projectColumnConf);
      } else {
        this.projectColums = null;
      }
      this.getSpecialProject();
      this.getRegionalDistribution();
      this.getIndustryDistribution();
      this.getRelationMapSpecialNews(row.id);
      this.getTopicHotWord();
      this.infiniteKey = new Date().getTime();
      this.infiniteKey1 = new Date().getTime();
    },
    getTopicList() {
      this.$iSpin.show();
      this.$pbrApis
        .getSpecialAll({})
        .then((data) => {
          this.tableLoading = false;
          if (data.success) {
            this.tableData = data.result;
          } else {
            this.tableData = [];
            //this.$iMessage.error({content: data.message})
          }
          this.$iSpin.hide();
        })
        .catch(() => {
          this.$iSpin.hide();
        });
    },
    fullGraph(graph) {
      this.$router.push({ name: "pbrFullTopics", params: { graph } });
    },
    changeGraph(event, arg) {
      // 1:国家 2:城市 3:行业 4:项目 5:企业 6:执行机构
      this.$refs.graph.graph.schema.types = [
        { k: 1, v: "国家" },
        { k: 2, v: "城市" },
        { k: 3, v: "行业" },
        { k: 4, v: "项目" },
        { k: 5, v: "企业" },
        { k: 6, v: "执行机构" },
      ];
    },
    getTopic() {
      this.$pbrApis.getTopic({}).then((res) => {
        if (res.success) {
          console.log("专题：", res);
          this.topic = res.result;
          if (res.result.projectColumnConf) {
            this.projectColums = JSON.parse(res.result.projectColumnConf);
          } else {
            this.projectColums = null;
          }
          this.getSpecialProject();
          this.getRegionalDistribution();
          this.getIndustryDistribution();
          this.getTopicNews();
          this.getRelationMapSpecialNews(res.result.id);
          this.getTopicHotWord();
        }
      });
    },
    getSpecialProject() {
      this.$pbrApis
        .getSpecialProject({ id: this.topic.id, lang: this.locale })
        .then((res) => {
          if (res.success) {
            this.pbrTopicProject = res.result.records;
            console.log("专题相关项目：", res);
          }
        });
    },
    getRegionalDistribution() {
      this.$pbrApis
        .getRegionalDistribution({ id: this.topic.id, lang: this.locale })
        .then((res) => {
          if (res.success) {
            this.regionDistChartData = res.result;
            console.log("地域分布：", res);
          }
        });
    },
    getIndustryDistribution() {
      this.$pbrApis
        .getIndustryDistribution({ id: this.topic.id, lang: this.locale })
        .then((res) => {
          if (res.success) {
            this.industryDistChatData = res.result;
            // this.industryDistChatData.splice(0,1)
            console.log("行业分布：", res);
          }
        });
    },
    getTopicNews() {
      this.$pbrApis
        .getTopicNews({ id: this.topic.id, lang: this.locale })
        .then((res) => {
          if (res.success) {
            console.log("专题新闻：", res);
            this.pbrTopicInfo = res.result.records;
          }
        });
    },
    getRelationMapSpecialNews(id) {
      this.$pbrApis
        .getRelationMapSpecialNews({
          id: id,
          conceptId: "6",
          tag: "1",
          lang: this.locale,
        })
        .then((res) => {
          if (res && res.code === 200) {
            this.graphValue.graph = res.result;
          }
        });
    },
    getTopicHotWord() {
      this.$pbrApis
        .getTopicHotWord({ id: this.topic.id, lang: this.locale })
        .then((res) => {
          if (res && res.code === 200) {
            this.hotWordDistChartData = res.result;
          }
        });
    },

    getSpecialAll() {
      this.$pbrApis.getSpecialAll({ lang: this.locale }).then((res) => {
        if (res && res.code === 200) {
          this.specialList = res.result;
        }
      });
    },
  },
  watch: {},
};
</script>
<style scoped>
.topic-table-title:hover {
  color: #33a2d7;
}
.pbr-topic-container {
  display: flex;
  flex-direction: column;
  align-items: center;
  font-size: 14px;
  line-height: 24px;
  overflow: auto;
}

.pbr-topicb-top-img {
  display: flex;
  width: 100%;
  background-size: cover;
  position: relative;
  /*background-image: url('static/images/pbr/topicb.png');*/
  /*background-size: cover;*/
  /*background-repeat: no-repeat;*/
  /*height: 108px;*/
}

.pbr-topicb-top-img > img {
  width: 100%;
}

.pbr-topic-content-container {
  display: flex;
  width: 100%;
  margin: 20px 0;
  justify-content: space-evenly;
}

.pbr-topic-content {
  display: flex;
  width: 100%;
  flex-direction: column;
  padding: 20px;
}

.pbr-topic-content-desc {
  text-indent: 2em;
  width: 250px;
  display: flex;
  align-items: center;
}

.pbr-topic-content-chart {
  display: flex;
  padding: 0 20px;
}

.pbr-topic-project-publish,
.pbr-topic-project-info,
.pbr-topic-project,
.pbr-topic-info {
  width: 80%;
  margin: 0 auto;
}

.pbr-topic-project-publish {
}

.pbr-topic-project-info {
}

.pbr-topic-project {
}

.pbr-topic-info {
}

.pbr-topicb-title-panel {
  height: 30px;
  border-radius: 15px;
  display: flex;
  align-items: center;
  background-color: #008bce;
}
.pbr-topicb-title-flex {
  justify-content: space-between;
}
.pbr-topicb-title-flex span {
  color: #fff;
  margin: 0 15px;
  cursor: pointer;
}

.pbr-topicb-title-panel strong {
  font-size: 16px;
  color: #fff;
  margin: 0 10px;
}

.pbr-topicb-title-panel-radio {
  color: #fff; /* ff3355 008bce*/
  margin-left: 8px;
  font-size: 18px;
}

.content-graph,
.graph-wrap {
  height: 100%;
}
>>> .pdvis-node-legend {
  display: none;
}
@media screen and (max-width: 768px) {
  .pbr-topic-content {
    padding: 20px 0;
  }
  .pbr-topic-project-publish,
  .pbr-topic-project-info,
  .pbr-topic-project,
  .pbr-topic-info {
    width: 100%;
  }
  .pbr-topic-content-desc {
    display: block;
    width: 30%;
    word-break: break-word;
  }
  .pbr-topic-content-chart {
    padding: 0;
  }
}
</style>
